module.exports = __webpack_public_path__ + "8a5356e9/img/share-action-icon.9c12578c.svg";